import React, { useState } from 'react';
import { ShoppingCart, User, Settings, MessageSquare, Check } from 'lucide-react';
import Capa from '../../assets/images/capaMovel.jpg';
import './Movel.css';

import AbaCarrinho from './AbaCarrinho';
import AbaDadosPessoais from './AbaDadosPessoais';
import AbaFaturaPix from './AbaFaturaPix';
import AbaSMS from './AbaSMS';

export default function Movel() {
  const [abaAtiva, setAbaAtiva] = useState('carrinho');

  const renderAba = () => {
    switch (abaAtiva) {
      case 'carrinho': return <AbaCarrinho />;
      case 'dados': return <AbaDadosPessoais />;
      case 'fatura': return <AbaFaturaPix />;
      case 'sms': return <AbaSMS />;
      default: return <AbaCarrinho />;
    }
  };

  return (
    <>
      <div className='capaMovel'>
        <img src={Capa} alt="Capa móvel" />
      </div>

      <div className="claro-container">
        <div className="header-nav">
          <div className="nav-items">
            <div className={`nav-item ${abaAtiva === 'carrinho' ? 'active' : ''}`} onClick={() => setAbaAtiva('carrinho')}>
              <ShoppingCart size={20} />
              <span>Carrinho</span>
            </div>
            <div className={`nav-item ${abaAtiva === 'dados' ? 'active' : ''}`} onClick={() => setAbaAtiva('dados')}>
              <User size={20} />
              <span>Dados Pessoais</span>
            </div>
            <div className={`nav-item ${abaAtiva === 'fatura' ? 'active' : ''}`} onClick={() => setAbaAtiva('fatura')}>
              <Settings size={20} />
              <span>Fatura | Pix</span>
            </div>
            <div className={`nav-item ${abaAtiva === 'sms' ? 'active' : ''}`} onClick={() => setAbaAtiva('sms')}>
              <MessageSquare size={20} />
              <span>SMS</span>
            </div>
          </div>
        </div>

        <div className="main-content">
          {/* Coluna 1: Conteúdo da aba ativa */}
          <div>{renderAba()}</div>

          {/* Coluna 2: Resumo sempre visível */}
          <div className="summary-section">
            <h3 className="summary-title">Resumo da compra</h3>

            <div className="price-section">
              <div className="price-label">
                <span>Valor Total</span>
              </div>
              <div className="price-value">
                R$ 59,90 <span className="price-period">/mês</span>
              </div>
              <div className="price-details">
                Boleto<br />
                Fidelizado por 12 meses
              </div>
            </div>

            <div className="plan-details">
              <div className="plan-brand">
                <span className="claro-brand">Giga</span>
                <span className="plan-type">controle</span>
              </div>
              <div className="plan-data">30GB</div>

              <div className="plan-features">
                <div className="feature">15GB Livres</div>
                <div className="feature">10GB de Bônus</div>
                <div className="feature">5GB de redes sociais</div>
                <div className="feature unlimited">LIGAÇÕES ILIMITADAS</div>
                <div className="feature">para qualquer lugar do Brasil</div>
              </div>
            </div>

            <div className="whatsapp-section">
              <div className="whatsapp-title">WhatsApp ilimitado: </div>
              <div className="whatsapp-icon">
                <Check size={16} />
              </div>
              <div className="whatsapp-description">Para redes sociais e vídeos</div>
            </div>

            <div className="social-icons">
              <div className="social-icon instagram">ig</div>
              <div className="social-icon facebook">f</div>
              <div className="social-icon tiktok">tt</div>
              <div className="social-icon twitter">x</div>
              <div className="social-icon youtube">yt</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
